module.exports = __webpack_public_path__ + "../resources/images/tasks-fa62548bf9584e462143842e3aeb40bd.svg";